import type { RecurringPayment } from "@sobidogam/domain";
import { buildIcs, firstOccurrence, type IcsReminder } from "@sobidogam/report";

const CAPTURE_URL = "https://sobidogam.com/app/capture";

/**
 * #39 달력 앱에 알림 넣기. Reminder bodies carry only the name the user gave
 * and a link to record — never amounts or merchants from their records.
 */
export function recurringReminder(
	payment: RecurringPayment,
	now = new Date(),
): IcsReminder {
	const repeat = { kind: "monthly", dayOfMonth: payment.dayOfMonth } as const;
	return {
		uid: `recurring-${payment.id}`,
		title: `${payment.name} 결제일`,
		description: `결제가 되면 소비도감에 한 건 기록해요. ${CAPTURE_URL}`,
		startDate: firstOccurrence(repeat, now),
		time: "09:00",
		repeat,
		url: CAPTURE_URL,
	};
}

export function monthCloseReminder(
	monthStartDay: number,
	now = new Date(),
): IcsReminder {
	const repeat = { kind: "monthly", dayOfMonth: monthStartDay } as const;
	return {
		uid: "month-close",
		title: "지난달 돌아보기",
		description: `새 달이 시작됐어요. 지난달 합계와 큰 지출을 돌아봐요. https://sobidogam.com/app`,
		startDate: firstOccurrence(repeat, now),
		time: "20:00",
		repeat,
		url: "https://sobidogam.com/app",
	};
}

export function weeklyReminder(now = new Date()): IcsReminder {
	const repeat = { kind: "weekly", weekday: "SU" } as const;
	return {
		uid: "weekly-record",
		title: "이번 주 빠진 결제 붙여 넣기",
		description: `일요일 저녁, 이번 주 결제 알림을 정리해요. ${CAPTURE_URL}`,
		startDate: firstOccurrence(repeat, now),
		time: "20:00",
		repeat,
		url: CAPTURE_URL,
	};
}

export function icsBlob(reminders: IcsReminder[]): Blob {
	return new Blob([buildIcs(reminders)], {
		type: "text/calendar;charset=utf-8",
	});
}
